import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { logoutReact } from './utilities/api';
import { classNames } from 'primereact/utils';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import defaultAvatar from './assets/default-avatar.png';
import NotificationBell from './common/NotificationBell/NotificationBell';
import './pages/custom.css';

const AppTopbar = (props) => {
    const navigate = useNavigate();

    const goDashboard = () => {
        navigate('/');
    };

    const op = useRef(null);
    const [username, setUsername] = useState('');

    const topbarItemsClassName = classNames('topbar-items fadeInDown', { 'topbar-items-visible': props.topbarMenuActive });
    const menuButtonClassName = classNames('p-link', { 'menu-button-rotate': props.rotateMenuButton });
    const profileItemClassName = classNames('profile-item', { 'active-top-menu': props.activeTopbarItem === 'profile' });

    useEffect(() => {
        // Get username from localStorage
        const storedUsername = localStorage.getItem('username');
        if (storedUsername) {
            setUsername(storedUsername);
        }
    }, []);

    const handleLogout = async () => {
        const userId = localStorage.getItem('userid');
        try {
            await logoutReact({ user_id: userId });
        } catch {
            // proceed with local logout even if server call fails
        }
        localStorage.clear();
        navigate('/');
    };

    return (
        <div className="topbar clearfix">
            <div className="topbar-left">
                <button className={menuButtonClassName} id="menu-button" onClick={props.onMenuButtonClick}>
                    <i className="pi pi-angle-left"></i>
                </button>

                <button className="p-link" onClick={goDashboard}>
                    {/* <img alt="Logo" src="assets/layout/images/logo-icon2.png" className="topbar-logo" /> */}
                    <span style={{ fontSize: 'x-large', fontWeight: 'bold' }} className="logo-text">
                        GravitySoft
                    </span>
                </button>
            </div>

            <div className="topbar-right" style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center' }}>
                <button className="p-link" id="topbar-menu-button" onClick={props.onTopbarMenuButtonClick}>
                    <i className="pi pi-bars"></i>
                </button>

                <NotificationBell />

                <Button label={`Welcome, ${username}`} icon="pi pi-chevron-down" iconPos="right" className="profile-button" onClick={(e) => op.current.toggle(e)}>
                    <img src={defaultAvatar} alt="User" className="user-avatar" />
                </Button>

                <OverlayPanel ref={op} className="profile-dropdown">
                    <ul className="dropdown-menu">
                        {/*    <li className="dropdown-item">
                            <i className="pi pi-user"></i> Profile
                        </li>
                        <li className="dropdown-item">
                            <i className="pi pi-cog"></i> Settings
                        </li> */}
                        <li className="dropdown-item logout" onClick={handleLogout}>
                            <i className="pi pi-sign-out"></i> Logout
                        </li>
                    </ul>
                </OverlayPanel>

                <ul className={topbarItemsClassName}>
                    {(props.profileMode === 'top' || props.horizontal) && (
                        <li className={profileItemClassName} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'profile' })}>
                            <button className="p-link">
                                <img alt="User" className="profile-image" src="assets/layout/images/avatar.png" />
                                <div>
                                    <span className="topbar-item-name">Isabel Lopez</span>
                                    <span className="topbar-item-role">Marketing</span>
                                </div>
                            </button>
                            <ul className="layout-menu fadeInDown">
                                <li role="menuitem">
                                    <button className="p-link">
                                        <i className="pi pi-fw pi-user"></i>
                                        <span>Profile</span>
                                    </button>
                                </li>
                                <li role="menuitem">
                                    <button className="p-link">
                                        <i className="pi pi-fw pi-lock"></i>
                                        <span>Privacy</span>
                                    </button>
                                </li>
                                <li role="menuitem">
                                    <button className="p-link">
                                        <i className="pi pi-fw pi-cog"></i>
                                        <span>Settings</span>
                                    </button>
                                </li>
                                <li role="menuitem">
                                    <button className="p-link">
                                        <i className="pi pi-fw pi-sign-out"></i>
                                        <span>Logout</span>
                                    </button>
                                </li>
                            </ul>
                        </li>
                    )}

                    {/*      <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'settings' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'settings' })}>
                        <button className="p-link">
                            <i className="topbar-icon pi pi-fw pi-cog"></i>
                            <span className="topbar-item-name">Settings</span>
                        </button>
                        <ul className="layout-menu fadeInDown">
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-palette"></i>
                                    <span>Change Theme</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-star-o"></i>
                                    <span>Favorites</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-lock"></i>
                                    <span>Lock Screen</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-image"></i>
                                    <span>Wallpaper</span>
                                </button>
                            </li>
                        </ul>
                    </li>

                    <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'messages' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'messages' })}>
                        <button className="p-link">
                            <i className="topbar-icon pi pi-fw pi-envelope"></i>
                            <span className="topbar-badge">5</span>
                            <span className="topbar-item-name">Messages</span>
                        </button>
                        <ul className="layout-menu fadeInDown">
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 1" src="assets/layout/images/avatar1.png" width="35" />
                                    <span>Give me a call</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 2" src="assets/layout/images/avatar2.png" width="35" />
                                    <span>Sales reports attached</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 3" src="assets/layout/images/avatar3.png" width="35" />
                                    <span>About your invoice</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 4" src="assets/layout/images/avatar2.png" width="35" />
                                    <span>Meeting today at 10pm</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link topbar-message">
                                    <img alt="Avatar 5" src="assets/layout/images/avatar4.png" width="35" />
                                    <span>Out of office</span>
                                </button>
                            </li>
                        </ul>
                    </li>

                    <li className={classNames({ 'active-top-menu': props.activeTopbarItem === 'notifications' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'notifications' })}>
                        <button className="p-link">
                            <i className="topbar-icon pi pi-fw pi-bell"></i>
                            <span className="topbar-badge animated rubberBand">4</span>
                            <span className="topbar-item-name">Notifications</span>
                        </button>

                        <ul className="layout-menu fadeInDown">
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-sliders-h"></i>
                                    <span>Pending tasks</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-calendar"></i>
                                    <span>Meeting today at 3pm</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-download"></i>
                                    <span>Download documents</span>
                                </button>
                            </li>
                            <li role="menuitem">
                                <button className="p-link">
                                    <i className="pi pi-fw pi-bookmark"></i>
                                    <span>Book flight</span>
                                </button>
                            </li>
                        </ul>
                    </li>     
                    <li className={classNames('search-item', { 'active-top-menu': props.activeTopbarItem === 'search' })} onClick={(e) => props.onTopbarItemClick({ originalEvent: e, item: 'search' })}>
                        <div className="topbar-search">
                            <input type="text" placeholder="Search" />
                            <i className="pi pi-search"></i>
                        </div>
                    </li> */}
                </ul>
            </div>
        </div>
    );
};

export default AppTopbar;
